<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-headers">
      <h3>{{ $i18n.t("Additional Properties") }}</h3>
    </v-btn>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Engine No.')"
          v-model="vehicle.vehicleDetail.engineNo"
          maxlength="20"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Chasis No.')"
          v-model="vehicle.vehicleDetail.chasisNo"
          maxlength="20"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('RC No.')"
          v-model="vehicle.vehicleDetail.rcNo"
          maxlength="15"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Inspection Fee')"
          v-model="vehicle.vehicleDetail.inspectionFee"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="6"
          type="number"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Vehicle Class')"
          v-model="vehicle.vehicleDetail.vehicleClass"
          maxlength="20"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-date-picker
          :label="$i18n.t('Registration Date')"
          v-model="vehicle.vehicleDetail.regDate"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :items="[{ name: 'Fleetx', value: 'Fleetx' }]"
          :label="$i18n.t('GPS Kind')"
          v-model="vehicle.vehicleDetail.gpsMfg"
          item-text="name"
          item-value="value"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          v-if="'Fleetx' == vehicle.vehicleDetail.gpsMfg"
          :label="$i18n.t('Fleetx Key')"
          v-model="vehicle.vehicleDetail.gpsMfg"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          v-if="'Fleetx' == vehicle.vehicleDetail.gpsMfg"
          :label="$i18n.t('Fleetx Secret')"
          v-model="vehicle.vehicleDetail.gpsSecret"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Settings",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Settings extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>